<ng-container *transloco="let t">
    <div class="tab-content-container" [innerHTML]="credits"></div>
</ng-container>
